<template>
  <Flex direction="column">
    <BaseRadio
      v-model="selectedAutomatedOption"
      :options="[
        {
          label: $t('marketing.email.automated_emails.waiting_list.manual'),
          value: DispatchTypeEnum.Manual
        },
        {
          label: $t('marketing.email.automated_emails.waiting_list.automated'),
          value: DispatchTypeEnum.Automatic
        }
      ]"
      v-test="'waiting-list-when-to-send-email'"
    />
    <BaseAlert
      v-if="showAutomatedWaitingListAlert"
      color="info"
      v-test="'waiting-list-when-to-send-email-alert'"
      :text="
        $t(
          'marketing.email.automated_emails.waiting_list.automated_description'
        )
      "
    />
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { DispatchTypeEnum } from '@/types';
import { useMarketingStore } from '../../store';

const { dispatchType } = storeToRefs(useMarketingStore());

const selectedAutomatedOption = ref<DispatchTypeEnum>(
  dispatchType.value ?? DispatchTypeEnum.Manual,
);

watch(dispatchType, (newValue) => {
  selectedAutomatedOption.value = newValue ?? DispatchTypeEnum.Manual;
});

const showAutomatedWaitingListAlert = computed(
  () => selectedAutomatedOption.value === DispatchTypeEnum.Automatic,
);

watch(selectedAutomatedOption, (value) => {
  dispatchType.value = value;
});
</script>
